<template>
  <span class="shared-step-editor-file-picker">
    <slot :open="open"></slot>

    <input
      ref="input"
      type="file"
      class="shared-step-editor-file-picker__input"
      :accept="accept"
      @change="onFileChange"
    />
  </span>
</template>

<script>
export default {
  props: {
    accept: {
      type: String,
      required: true,
    },
  },
  methods: {
    onFileChange(event) {
      const input = event.target;
      const [file] = input.files ?? [];
      if (file) {
        if (!this.accept.includes(file.type)) {
          $.notify('Only JPG, PNG and JPEG files are allowed', 'error');
          return;
        }
        this.$emit('select-file', file);
        input.value = '';
      }
    },
    open() {
      this.$refs.input.click();
    },
  },
};
</script>

<style lang="scss" scoped>
.shared-step-editor-file-picker {
  &__input {
    display: none;
  }
}
</style>
